import { ca } from '@cian/analytics';

const mapTitle: { [key: number]: string } = {
  0: 'Developers',
  1: 'Realtors',
  2: 'Agency',
  3: 'Bank',
  4: 'Insurance',
};

export function trackAccordionTitleClick(nextActiveIndex: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: mapTitle[nextActiveIndex],
  });
}

export function trackArrowClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: 'Arrow',
  });
}
